export default __webpack_public_path__ + "static/media/element_25.c1e7da2d.jpg";